<div class="container-fluid" style="overflow-y: auto;">
	<div class="row">
		<div class="col-md-12">
			<h1>
				<span jhiTranslate="label-printing.title">EXPORT DATA / LABEL PRINTING</span>
                <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
			</h1>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12">
			<div class="card panel-default">
				<div class="card-body">
					<div *ngIf="initComplete else loading">
						<div class="row">
							<h4 class="col-md-12" *ngIf="isLabelPrinting()" jhiTranslate="label-printing.header.print.labels">Print labels</h4>
							<h4 class="col-md-12" *ngIf="!isLabelPrinting()" jhiTranslate="label-printing.header.export.data">Export data</h4>
						</div>
						<div class="row" *ngIf="hasHeader()">
							<div class="col-md-6">
								<h4 class="sub-content-heading" jhiTranslate="label-printing.selected.study">Selected study</h4>
								<div>
									<div *ngFor="let key of metadataKeys">
										<label class="col-form-label fw-bold">
											{{ getJsonKey(key) | translate }}
										</label>
										<span class="ms-1">{{metadata.get(key)}}</span>
									</div>
								</div>
							</div>
							<div class="col-md-6" *ngIf="isLabelPrinting()">
								<div class="row">
									<div class="col-md-12">
										<h4 class="sub-content-heading" jhiTranslate="label-printing.summary.of.labels.needed">
											SUMMARY OF LABELS NEEDED</h4>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<table class="table table-striped table-bordered">
											<thead>
											<tr>
												<th *ngFor="let header of labelsNeededSummary.headers">{{header}}</th>
											</tr>
											</thead>
											<tbody>
											<tr *ngFor="let row of labelsNeededSummary.values;">
												<td *ngFor="let header of labelsNeededSummary.headers">{{row[header]}}</td>
											</tr>
											</tbody>
										</table>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12 text-end">
										<label class="col-form-label fw-bold" jhiTranslate="label-printing.total.number.of.labels">
											Total # of Labels to Print</label>:&nbsp;
										<span>{{labelsNeededSummary.totalNumberOfLabelsNeeded}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="row" *ngIf="isForGermplasmListLabelPrinting()">
							<div class="col-md-6">
								<h4 class="sub-content-heading" jhiTranslate="label-printing.selected.germplasm.list">Selected List</h4>
								<div>
									<div *ngFor="let key of metadataKeys">
										<label class="col-form-label fw-bold">
                                            {{ getJsonKey(key) | translate }}
										</label>
										<span class="ms-1">{{metadata.get(key)}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-6">
								<h4 class="sub-content-heading" jhiTranslate="label-printing.preset.heading">
									Preset options
								</h4>
								<div class="col-md-12 ">
									<div class="row">
										<div class="col-md-4">
                                            <div class="form-check">
                                                <input type="checkbox" class="form-check-input"
                                                       [(ngModel)]="loadSavedSettings" id="loadSavedSettings"
                                                       checked=""/>
                                                <label class="form-check-label" for="loadSavedSettings" jhiTranslate="label-printing.preset.load.saved"> Load saved
                                                    settings: </label>
                                            </div>
										</div>
										<div class="col-md-6" style="padding-left: 0px;">
                                            <div class="d-flex align-items-center justify-content-start">
											<select *ngIf="loadSavedSettings" class="form-select" [(ngModel)]="presetSettingId" (ngModelChange)="applySelectedSetting()">
												<option [value]="0" jhiTranslate="global.please.choose">Please Choose</option>
												<option *ngFor="let presetSetting of presetSettings" [value]="presetSetting.id">{{presetSetting.name}}</option>
											</select>
                                            <a *ngIf="loadSavedSettings &&  presetSettingId!=0" class="ms-2"><i class="fa fa-trash" (click)="deleteSelectedSetting()"></i></a>
                                            </div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-6">
								<h4 class="sub-content-heading" jhiTranslate="label-printing.choose.output">
									CHOOSE OUTPUT
								</h4>
								<div class="col-md-12 row" style="margin-bottom: 0px;">
									<label class="col-form-label " jhiTranslate="label-printing.choose.format">
										Choose the format you would like to use:</label>
								</div>
								<div class="row">
									<label class="col-md-5 col-form-label fw-bold" jhiTranslate="label-printing.output.format">:</label>
									<div class="col-md-6">
										<select class="form-select" [(ngModel)]="fileType" (ngModelChange)="reset()">
											<option [value]="FILE_TYPES.NONE" jhiTranslate="global.please.choose">Please Choose</option>
											<option [value]="FILE_TYPES.PDF">Formatted PDF Label Sheets</option>
											<option [value]="FILE_TYPES.EXCEL">Excel Data</option>
											<option [value]="FILE_TYPES.CSV">CSV Data</option>
										</select>
									</div>
								</div>
								<div *ngIf="sortableFields != null && sortableFields.length !=0" class="row">
									<label class="col-md-5 col-form-label fw-bold" jhiTranslate="label-printing.sort.label.by">:</label>
									<div class="col-md-6">
										<select class="form-select" [(ngModel)]="sortBySelected">
											<option value="" jhiTranslate="global.please.choose">Please Choose</option>
											<ng-container *ngFor="let sortableField of sortableFields">
												<option [value]="sortableField.sortBy">
													<label>{{sortableField.fieldName}}</label>
												</option>
											</ng-container>
										</select>
									</div>
								</div>
							</div>
						</div>
						<div class="row" *ngIf="fileType === FILE_TYPES.PDF">
							<div class="col-md-12">
								<h4 class="sub-content-heading" jhiTranslate="label-printing.specify.label.stock">
								</h4>
							</div>
							<div class="col-md-6">
								<div class="row">
									<div class="col-md-12">
										<label class="col-form-label" jhiTranslate="label-printing.enter.specs.for.label"></label>
									</div>
								</div>
								<div class="row">
									<div class="col-md-7">
										<label class="col-form-label fw-bold" jhiTranslate="label-printing.size.of.label.sheet"></label>:
									</div>
									<div class="col-md-5">
										<select [(ngModel)]="labelPrintingData.sizeOfLabelSheet" class="form-select">
											<option value="1" jhiTranslate="label-printing.label.size.a4">A4</option>
											<option value="2" jhiTranslate="label-printing.label.size.letter">Letter</option>
										</select>
									</div>
								</div>
								<div class="row">
									<div class="col-md-7">
										<label class="col-form-label fw-bold" jhiTranslate="label-printing.number.of.rows.per.page"></label>:
									</div>
									<div class="col-md-5">
										<select [(ngModel)]="labelPrintingData.numberOfRowsPerPage" class="form-select">
											<option value="7">7</option>
											<option value="8">8</option>
											<option value="10">10</option>
										</select>
									</div>
								</div>
							</div>
							<div class="col-md-6">
								<div class="col-md-12">&nbsp;</div>
								<div class="col-md-12">
									<br/>
									<em jhiTranslate="label-printing.specify.label.details.message"></em>
								</div>
							</div>
						</div>
						<div *ngIf="fileType">
							<div class="col-md-12">
								<h4 class="row sub-content-heading" jhiTranslate="label-printing.choose.fields">
									CHOOSE FIELDS
								</h4>
								<div class="row" *ngIf="fileType !== FILE_TYPES.PDF">
									<div class="col d-flex align-items-center justify-content-start">
                                        <label class="fw-bold" jhiTranslate="label-printing.include.headings">Include column headings in XLS export?</label>
                                        <label class="form-check ms-2">
                                            <input class="form-check-input" type="radio" name="include-heading-options" [value]="true" [(ngModel)]="labelPrintingData.includeHeadings">
                                            <span jhiTranslate="label-printing.include.headings.yes">Yes</span>
                                        </label>
                                        <label class="form-check ms-2">
                                            <input class="form-check-input" type="radio" name="include-heading-options" [value]="false" [(ngModel)]="labelPrintingData.includeHeadings">
                                            <span jhiTranslate="label-printing.include.headings.no">No</span>
                                        </label>
                                    </div>
								</div>
								<div class="row">
									<div [innerHTML]="getChooseLabelDescription()"></div>
								</div>
							</div>
							<div class="col-md-12">
								<h4 class="row sub-content-heading">
									&nbsp;
								</h4>
								<div class="row" cdkDropListGroup>
									<div class="col-md-6">
										<div class="row">
											<div *ngFor="let labelType of labelTypes">
                                                <div class="card">
                                                    <h5 class="card-header">
                                                        <label  (click)="collapsedMap[labelType.title] = !collapsedMap[labelType.title]">
                                                            <i [ngClass]="collapsedMap[labelType.title]?'fa fa-caret-right fa-lg':'fa fa-caret-down fa-lg'" aria-hidden="true"> </i>
                                                            {{labelType.title}}
                                                        </label>
                                                        <div *ngIf="!collapsedMap[labelType.title]">
                                                            <div class="input-group mb-3 mt-2">
                                                                <input #search type="text" class="form-control" placeholder="{{'label-printing.search.list' | translate}}" aria-label="Search list" aria-describedby="clearSearch"
                                                                       [(ngModel)]="selectedFilterTextMap[labelType.title]">
                                                                <button class="btn btn-outline-secondary" type="button" id="clearSearch" (click)="selectedFilterTextMap[labelType.title] = ''"><i class="fa fa-times"></i></button>
                                                            </div>
                                                        </div>
                                                    </h5>
                                                    <div [class.collapse]="collapsedMap[labelType.title]">
                                                        <div class="card-body p-0 label-printing-list custom-scroll-style">
                                                            <div *ngIf="!collapsedMap[labelType.title]" id="{{labelType.title}}"
                                                                 cdkDropList
                                                                 [cdkDropListData]="labelType.fields"
                                                                 (cdkDropListDropped)="drop($event)">
                                                                <div class="label-box"
                                                                     cdkDrag [cdkDragData]="item"
                                                                     *ngFor="let item of labelType.fields | fieldListFilter: selectedFilterTextMap[labelType.title]">
                                                                    <div class="label-printing-custom-placeholder" *cdkDragPlaceholder></div>
                                                                    {{item.name}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
											</div>
										</div>
									</div>
									<div class="col-md-6">
										<div class="row">
                                            <div *ngFor="let labelType of fieldsSelected">
                                                <div class="card">
                                                    <h5 class="card-header">
                                                        <label class="list-group-item col-form-label fw-bold">
                                                            {{ this.getSelectedLabelsHeader(labelType.title) | translate }}
                                                            <a class="float-end" href (click)="resetSelectedFieldsTable($event,labelType)"
                                                               jhiTranslate="label-printing.remove.selected.fields"> Remove all</a>
                                                            <div class="input-group mb-3" style="padding-top: 5px;">
                                                                <input #search type="text" class="form-control" placeholder="{{'label-printing.search.list' | translate}}" aria-label="Search list" aria-describedby="clearSearch"
                                                                       [(ngModel)]="selectedFilterTextMap[labelType.title]">
                                                                <button class="btn btn-outline-secondary" type="button" id="clearSearch" (click)="selectedFilterTextMap[labelType.title] = ''"><i class="fa fa-times"></i></button>
                                                            </div>
                                                        </label>
                                                    </h5>
                                                    <div [class.collapse]="collapsedMap[labelType.title]">
                                                        <div class="card-body p-0 label-printing-list custom-scroll-style" cdkDropList
                                                             [cdkDropListData]="labelType.fields"
                                                             (cdkDropListDropped)="drop($event)" id="{{labelType.title}}">
                                                            <div >
                                                                <div class="label-box"
                                                                     cdkDrag [cdkDragData]="item"
                                                                     *ngFor="let item of labelType.fields | fieldListFilter: selectedFilterTextMap[labelType.title]">
                                                                    <div class="label-printing-custom-placeholder" *cdkDragPlaceholder></div>
                                                                    <div class="align-items-center">
                                                                        <button (click)="removeItem(labelType,item)" type="button" class="btn btn-sm btn-outline-danger justify-content-end">
                                                                            <span class="fa fa-times-circle"></span>
                                                                        </button>
                                                                        <span class="ms-2">{{item.name}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- Barcodes section -->
							<div class="row" *ngIf="isLabelPrinting()">
								<div class="col-md-12">
									<div class="row">
										<div class="col-md-6">
											<h4 class="sub-content-heading" jhiTranslate="label-printing.barcode.options">
												Barcode Options
											</h4>
											<div class="row">
                                                <div class="col">
                                                    <label class="form-check form-check-inline fw-bold" jhiTranslate="label-printing.do.you.need.bar.codes"> Do you need barcodes on your labels?</label>
                                                    <label class="form-check form-check-inline">
                                                        <input class="form-check-input" type="radio" name="barcodeNeededRadio" [value]="true" [(ngModel)]="labelPrintingData.barcodeNeeded"/>
                                                        <span jhiTranslate="label-printing.do.you.need.bar.codes.yes">Yes</span>
                                                    </label>
                                                    <label class="form-check form-check-inline">
                                                        <input class="form-check-input" checked="checked" type="radio" name="barcodeNeededRadio" [value]="false" [(ngModel)]="labelPrintingData.barcodeNeeded"/>
                                                        <span jhiTranslate="label-printing.do.you.need.bar.codes.no">No</span>
                                                    </label>
                                                </div>
											</div>
											<div *ngIf="labelPrintingData.barcodeNeeded" class="row mt-2">
                                                <div class="col">
                                                    <label class="form-check form-check-inline fw-bold" jhiTranslate="label-printing.do.you.want.automatically.unique.bar.codes"> Do you want to use automatically generated unique barcodes?</label>
                                                    <label class="form-check form-check-inline">
                                                        <input class="form-check-input" checked="checked" type="radio" name="barcodeGeneratedAutomaticallyRadio" [value]="true" [(ngModel)]="labelPrintingData.barcodeGeneratedAutomatically"/>
                                                        <span jhiTranslate="common.form.yes.text">Yes</span>
                                                    </label>
                                                    <label class="form-check form-check-inline">
                                                        <input class="form-check-input" type="radio" [value]="false" name="barcodeGeneratedAutomaticallyRadio" [(ngModel)]="labelPrintingData.barcodeGeneratedAutomatically"/>
                                                        <span jhiTranslate="common.form.no.text">No</span>
                                                    </label>
                                                </div>
											</div>
										</div>
										<div class="col-md-6" *ngIf="labelPrintingData.barcodeNeeded && !labelPrintingData.barcodeGeneratedAutomatically">
											<div>
												<label class="col-form-label" jhiTranslate="label-printing.bar.code.note"></label>
											</div>
											<div class="row">
												<div class="col-md-4">
													<label class="col-form-label fw-bold"
														   jhiTranslate="label-printing.first.bar.code.field"></label>:
												</div>
												<div class="col-md-8">
													<select [(ngModel)]="labelPrintingData.firstBarcodeField" class="form-select">
														<option [value]="''" jhiTranslate="label-printing.bar.code.please.choose.field" jhiTranslate="global.please.choose">Please Choose</option>
														<option *ngFor="let field of allLabels" [value]="field | transformToCombinedKey">
															{{field.name}}
														</option>
													</select>
												</div>
											</div>
											<div class="row">
												<div class="col-md-4">
													<label class="col-form-label fw-bold" jhiTranslate="label-printing.second.bar.code.field"></label>:
												</div>
												<div class="col-md-8">
													<select [(ngModel)]="labelPrintingData.secondBarcodeField" class="form-select">
														<option [value]="''" jhiTranslate="label-printing.bar.code.please.choose.field" jhiTranslate="global.please.choose">Please Choose</option>
														<option *ngFor="let field of allLabels" [value]="field | transformToCombinedKey">
															{{field.name}}
														</option>
													</select>
												</div>
											</div>
											<div class="row">
												<div class="col-md-4">
													<label class="col-form-label fw-bold" jhiTranslate="label-printing.third.bar.code.field"></label>:
												</div>
												<div class="col-md-8">
													<select [(ngModel)]="labelPrintingData.thirdBarcodeField" class="form-select">
														<option [value]="''" jhiTranslate="label-printing.bar.code.please.choose.field" jhiTranslate="global.please.choose">Please Choose</option>
														<option *ngFor="let field of allLabels" [value]="field | transformToCombinedKey">
															{{field.name}}
														</option>
													</select>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div> <!-- /Barcodes section -->
							<div class="row">
								<div class="col-md-12">
									<div class="row">
										<div class="col-md-6">
											<h4 class="sub-content-heading" jhiTranslate="label-printing.filename.description">
												Specify the name of the file
											</h4>
											<div class="row">
												<div class="col-md-3">
													<label class="col-form-label fw-bold" jhiTranslate="label-printing.filename">:</label>
												</div>
												<div class="col-md-5">
													<input type="text" class="form-control" [(ngModel)]="labelPrintingData.filename" placeholder="{{'label-printing.filename' | translate}}" required/>
												</div>
											</div>
										</div>
										<div class="col-md-6">
											<h4 class="sub-content-heading" jhiTranslate="label-printing.save.preset.heading">
												Save settings
											</h4>
											<div>
												<label class="col-form-label"
													   jhiTranslate="label-printing.choose.preset.text"></label>
											</div>
											<div class="row">
												<label class="col-form-label col-md-3 fw-bold" jhiTranslate="label-printing.save.preset.name.note">:</label>
												<div class="col-md-5">
													<input type="text" class="form-control" [(ngModel)]="labelPrintingData.settingsName" placeholder="{{'label-printing.save.preset.settings.name' | translate}}"/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div> <!-- /label-printing-details -->
						</div>
						<div class="row">
							<div class="col-md-12">
								&nbsp;
							</div>
						</div>
						<div class="modal-footer">
							<button (click)="back()" type="button" class="btn btn-secondary ms-2" value="Cancel">
								<span class="fa fa-ban"></span>&nbsp;{{ 'cancel' | translate }}
							</button>
							<button *ngIf="fileType" id="fbk-lbl-printing-save-preset" (click)="savePresets()" class="btn btn-info ms-2" [disabled]="isPresetSaving">
                                <span *ngIf="isPresetSaving" class="throbber throbber-btn"></span>
                                <span class="fa fa-save"></span>&nbsp;{{ 'save.preset' | translate }}
							</button>
							<button *ngIf="fileType" (click)="export()" class="btn btn-primary ms-2" [disabled]="isLoading">
								<span *ngIf="isLoading" class="throbber throbber-btn"></span>
                                {{ 'export' | translate }}
							</button>
						</div>
						<div class="row">
							&nbsp;
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #loading>
	<div style=" display: flex; justify-content: center; align-items: center; margin: 20px ">
		<span class="throbber"></span>
	</div>
</ng-template>
